// extracted by mini-css-extract-plugin
export default {"iframe":"Viewer_iframe__2fhpY","empty":"Viewer_empty__WRXs+","video":"Viewer_video__Ba5Q6"};